package com.milta.core.localization.translations.en

import com.milta.core.localization.SubscriptionExpiredStrings

internal val SubscriptionExpired = SubscriptionExpiredStrings(
    title = "Subscription expired",
    driverSoloMessage = "Your subscription has expired. Renew to continue.",
    patronMessage = "Your subscription has expired. Your team can no longer access Milta.",
    driverUnderPatronMessage = "Your organisation's subscription has expired. Contact your organisation to restore your access.",
    renewButton = "Renew",
    close = "Close",
    subscribeButtonTemplate = "Subscribe for %s",
)
